import { Box, Grid, TextField, Typography } from "@mui/material"
import { useTranslation } from "react-i18next";

interface IValidationRuleLowerTitle {
    setName: (set: string) => void;
    setDescription: (set: string) => void;
    name: string;
    description: string;
}

export const ValidationRuleLowerTitle: React.FC<IValidationRuleLowerTitle> = ({
    setDescription,
    setName,
    description,
    name
}) => {

    const { t } = useTranslation();

    return (
        <>
            <Box
                display="flex"
                flexDirection="column"
                mb="34px"
            >
                <Typography
                    sx={{
                        textAlign: "left",
                        font: "normal normal 600 16px/24px Segoe UI",
                        letterSpacing: "0px",
                        color: "#2D2D2D",
                        opacity: 1,
                    }}
                >
                        {t("ValidationRule.validationRuleInformation")}
                </Typography>
                <Box
                    display="flex"
                >
                    <Grid container>
                        <Grid item xs={3} mr="20px">
                            <TextField 
                                variant='standard'
                                label={
                                    <Typography
                                        sx={{
                                            textAlign: "left",
                                            font: "normal normal normal 12px/18px Segoe UI",
                                            letterSpacing: "0px",
                                            color: "#2D2D2D",
                                            opacity: 1,
                                        }}
                                    >
                                        {t("ValidationRule.validationRuleName")}
                                    </Typography>
                                }
                                fullWidth
                                value={name}
                                inputProps={{ maxLength: 75 }}
                                onChange={e => setName(e.target.value)}
                            />
                        </Grid>
                        <Grid item xs={8} mr="20px">
                            <TextField 
                                variant='standard'
                                label={
                                    <Typography
                                        sx={{
                                            textAlign: "left",
                                            font: "normal normal normal 12px/18px Segoe UI",
                                            letterSpacing: "0px",
                                            color: "#2D2D2D",
                                            opacity: 1,
                                        }}
                                    >
                                        {t("ValidationRule.validationRuleDescription")}
                                    </Typography>
                                }
                                fullWidth
                                value={description}
                                inputProps={{ maxLength: 500 }}
                                onChange={e => setDescription(e.target.value)}
                            />
                        </Grid>
                    </Grid>
                    
                </Box>
            </Box>
            <Typography
                sx={{
                    textAlign: "left",
                    font: "normal normal 600 16px/24px Segoe UI",
                    letterSpacing: "0px",
                    color: "#2D2D2D",
                    opacity: 1,
                    mb: "8px"
                }}
            >
                {t("ValidationRule.validationActivity")}
            </Typography>
            <Typography
                sx={{
                    textAlign: "left",
                    font: "normal normal normal 14px/21px Segoe UI",
                    letterSpacing: "0px",
                    color: "#2D2D2D",
                    opacity: 0.8,
                    mb: "20px"
                }}
            >
                {t("ValidationRule.validationRuleSteps")}
            </Typography>
        </>
    )
}